export default "__VITE_ASSET__01ad04c4__"